<template>
  <section class="section">
    <div class="container">
      <div class="tabs">
        <ul>
          <router-link tag="li" :to="{ name: 'nominaconfiguracion.empleados' }">
            <a><small>Empleados</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link
            tag="li"
            :to="{ name: 'nominaconfiguracion.devengados' }"
          >
            <a><small>Devengados y deducciones</small></a>
          </router-link>
        </ul>
      </div>
      <div v-if="isinicial">
        <div class="notification">
          <h1 class="title is-4">Configuración</h1>
          <h2 class="subtitle is-6">Configuraciones del sistema</h2>
          <p>
            Hacinedo clic en alguna de las opciones de arriba podrá configurar
            las diferentes opciones del sistema. Como empresa, documentos,
            cuentas, terceros. etc.
          </p>
        </div>
      </div>

      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      routeaqui: null,
    };
  },
  computed: {
    isinicial() {
      return this.$route.name === "nominaconfiguracion";
    },
  },
  created() {
    this.routeaqui = this.$route.name;
  },
};
</script>

<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #3273dc;
  color: #3273dc;
}
</style>


// WEBPACK FOOTER //
// src/components/nomina/Configuracion.vue